import React, {useEffect, useState} from "react";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_RANK_DATA_REPORT_API} from "../../constants/api_constants";
import {getImage} from "../../constants/constants";

const RankingTableFromReport = ({dataId, analysisType}) => {
  const [rankData, setRankData] = useState([]);
  const [homeName, setHomeName] = useState(null);
  const [awayName, setAwayName] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getRankData();
  }, []);

  const getRankData = () => {
    // 최근 전적
    getFetcherAnalysis().get(GET_RANK_DATA_REPORT_API + `?dataId=${dataId}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data[0].categories === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            console.log("API 응답 데이터:", data[0]?.categories);
            setRankData(data[0]?.categories || []);
            setHomeName(data[0].homeTeamName);
            setAwayName(data[0].awayTeamName);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }

  function isSameTeam(currentName, sourceName) {
    if (currentName.endsWith('..')) {
      // 이름 길어서 잘릴경우 잘리기전까지 비교
      let c = currentName.replace(' ', '');
      c = c.substring(0, c.length - 2);
      let s = sourceName.replace(' ', '');
      if (s.length > c.length) {
        return c === s.substring(0, c.length);
      }
    }
    return currentName === sourceName;
  }


  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  return (
      <div className="w-full h-full">
        <span className="text-xl font-bold px-2">순위</span>
        <div className="w-full border-t-2 border-gray-900 my-1"/>

        <div className="max-h-[calc(100%-10rem)] mt-3 mb-5">
          {rankData?.map((category, index) => {
            const hasRankName = Boolean(category?.rankName);
            return (
                <div className={neverLandUtils.classNames(index !== 0 ? "mt-7": "","flex flex-col")} key={index}>
                  {/* 이름 */}
                  {hasRankName && (
                      <h2 className="flex justify-center items-center bg-amber-300 mb-1 py-0.5 font-bold">
                        {category?.rankName}
                      </h2>
                  )}

                  <table className="w-full text-sm">
                    {/* 테이블 헤더 */}
                    <thead className="text-center bg-gray-900 text-white">
                    <tr>
                      {category?.rankColumns?.map((colName, colIndex) => (
                          <th className="py-1.5" key={colIndex}>
                            {colName}
                          </th>
                      ))}
                    </tr>
                    </thead>

                    {/* 테이블 바디 */}
                    <tbody className="divide-y divide-stone-300 text-center border-y border-gray-300">
                    {category?.rankData?.map((data, rowIndex) => {
                      const isHomeTeam = isSameTeam(data.teamName, homeName);
                      const isAwayTeam = isSameTeam(data.teamName, awayName);

                      return (
                          <tr key={rowIndex}
                              className={neverLandUtils.classNames(isHomeTeam ? "ring-2 ring-red-600 bg-red-100"
                                  : isAwayTeam ? "ring-2 ring-blue-600 bg-blue-100" : "ring-1 ring-gray-100", ""
                              )}
                          >
                            {/* 순위 */}
                            <td className="p-1.5 py-2">{data.points[0] ?? "-"}</td>

                            {/* 팀이름 */}
                            <td>
                              <p className={neverLandUtils.classNames(isHomeTeam ? "bg-red-600 text-white"
                                  : isAwayTeam ? "bg-blue-600 text-white" : "bg-white ring-1 ring-gray-300", "rounded-xl p-1 shadow-md"
                              )}
                              >
                                {neverLandUtils.trimTeamName(data.teamName)}
                              </p>
                            </td>

                            {/* 나머지 값 */}
                            {data.points.slice(2).map((point, idx) => (
                                <td key={idx + 2}>{point ?? "-"}</td>
                            ))}
                          </tr>
                      );
                    })}
                    </tbody>
                  </table>
                </div>
            );
          })}
        </div>
      </div>
  );
}
export default RankingTableFromReport;